import React from 'react';

import { Stack } from '@mui/system';
import { Typography } from '@mui/material';

import styles from './error5xx.module.scss';

export const Error5xx = () => (
  <Stack className={styles.container} data-testid="component-error-5xx">
    <Typography variant="h1">Something went wrong!</Typography>
    <Typography variant="body1">There was an unexpected problem, please try again later.</Typography>
  </Stack>
);
